import DraggableStepCard from '../../DraggableStepCard';
import {
  getNotifyMemberViaEmailFromString,
  getSendEmailFromString,
  getValueOrDeleted,
} from './action-helpers';

export const content = ({ step }) => step.description;

export const getDescription = ({ step, t, business }) => {
  const { details } = step;
  return t('Email ‘{{subject}}’ to {{recipient}} from {{sender}}', {
    subject: getValueOrDeleted(details?.email?.subject, t),
    recipient:
      getNotifyMemberViaEmailFromString(details.ccTeamMember, t) || t('None'),
    sender: getSendEmailFromString(details, business, t),
  });
};

export default function SendEmailCard({ type, step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
